import { BeaconDto, BeaconListResponse, UnregesterdBeaconListResponse } from "types/beacon";
import { blobDownload, genericDelete, genericGet, genericPost, genericPut, UploadFile } from "./base.api";
import { getDataApiUrl } from "utils/utils";

export function getBeaconList(params?: Record<string, any>): Promise<BeaconListResponse> {
  return genericGet(`${getDataApiUrl()}/localized/beacons`, params);
}

export function getAssignedBeaconsList(): Promise<BeaconListResponse> {
  return genericGet(`${getDataApiUrl()}/localized/beacons`, {
    is_assigned_to_asset_filter: true
  });
};

export function getUnassignedBeaconsList(): Promise<BeaconListResponse> {
  return genericGet(`${getDataApiUrl()}/localized/beacons`, {
    is_assigned_to_asset_filter: false
  });
};

export function getBeacon(beacon_id: string): Promise<BeaconDto> {
  return genericGet(`${getDataApiUrl()}/beacons/${beacon_id}`)
}

export function getUnregisteredBeaconList(source: string, params?: Record<string, any>)
  : Promise<UnregesterdBeaconListResponse> {
  return genericGet(`${getDataApiUrl()}/unregistered_beacons/${source}`, params);
}

export function DownloadTemplateFile() {
  return blobDownload(`${getDataApiUrl()}/device/beacon/job/template`, null, 'GET', 'beacon_import_template.csv')
};

export function UploadBeacons(file: any) {
  return UploadFile(`${getDataApiUrl()}/beacons/bulk_upload`, file)
}

export async function createBeacon(beaconData: any): Promise<any> {
  return genericPost(`${getDataApiUrl()}/beacons`, { beacon: beaconData })
};

export async function updateBeacon(beaconData: any): Promise<any> {
  return genericPut(`${getDataApiUrl()}/beacons`, { beacon: beaconData })
};

export async function deleteBeacon(beacon_id: string): Promise<any> {
  return genericDelete(`${getDataApiUrl()}/beacons/${beacon_id}`)
};